export default class Eraser {
	eraserRadius = 10;
	isMouseDown = false;
	selector = null;
	erasedListener = [];

	constructor(svg) {
		this.svg = svg;

		this.svg.addEventListener("mousedown", this.onMouseDown.bind(this));
		this.svg.addEventListener("mouseup", this.onMouseUp.bind(this));
		this.svg.addEventListener("mousemove", this.onMouseMove.bind(this));
	}

	init(selector) {
		this.selector = selector;
	}

	listenOnErased(callBack) {
		this.erasedListener.push(callBack);
	}

	erased(element) {
		this.erasedListener.forEach((callBack) => {
			callBack(element);
		});
	}

	onMouseDown(event) {
		this.isMouseDown = true;
		this.erase(event);
	}

	onMouseUp() {
		this.isMouseDown = false;
	}

	onMouseMove(event) {
		if (this.isMouseDown) {
			this.erase(event);
		}
	}

	erase(event) {
		if (!this.selector) {
			console.log("Erase selector is not definied.");
			return;
		}

		const point = this.svg.createSVGPoint();
		point.x = event.clientX;
		point.y = event.clientY;

		const svgPoint = point.matrixTransform(this.svg.getScreenCTM().inverse());

		const mouseX = svgPoint.x;
		const mouseY = svgPoint.y;

		const elements = this.svg.querySelectorAll(`[id$="${this.selector}"]`);

		elements.forEach((element) => {
			const bbox = element.getBBox();

			if (
				mouseX >= bbox.x - this.eraserRadius &&
				mouseX <= bbox.x + bbox.width + this.eraserRadius &&
				mouseY >= bbox.y - this.eraserRadius &&
				mouseY <= bbox.y + bbox.height + this.eraserRadius
			) {
				this.erased(element);
			}
		});
	}
}
